import React from 'react'
import PropTypes from 'prop-types'
import { InputGroup } from 'react-bootstrap'

const FormInputAddon3 = (props) => {
  return (
    <InputGroup.Addon
      className={props.className}
    >
      {props.children}
    </InputGroup.Addon>
  )
}

FormInputAddon3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

FormInputAddon3.defaultProps = {
  className: ''
}

export default FormInputAddon3
